import { tap, map } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { AllPredictions } from '@core/models/all-predictions.model';

@Injectable()
export class AllPredictionsDataService extends DefaultDataService<AllPredictions>  {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('AllPredictions', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<AllPredictions[]> {
    return this.http.get<ApiResponse>('/event/predictions').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<AllPredictions[]>{
    return this.http.get<ApiResponse>(`/event/predictions${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  exportPrediction(params: string) {
    return this.http.get<ApiResponse>(`/event/predictions/export${params}`).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
